// extracted by mini-css-extract-plugin
export var card = "_93-0";
export var expandedCard = "_93-2";
export var paginated = "_93-1";